import {
  Grid2 as Grid,
  Tab,
  Tabs,
  Container,
  Button,
} from "@mui/material";
import { Navigate, useNavigate } from "react-router-dom";

import FhirServer from "./FhirServer";
import CreateFhirServerDialog from "./CreateFhirServerDialog";
import { gql } from "@apollo/client";
import { useFhirServersQuery } from "~/graphql/__generated__/graphql";
import { useState } from "react";

interface TabEhrIntegrationProps {
  id?: number;
}

const TabEhrIntegration = ({ id }: TabEhrIntegrationProps) => {
  const { data, loading } = useFhirServersQuery();
  const navigate = useNavigate();
  const [createOpen, setCreateOpen] = useState(false);

  if (!id) {
    const fhirServerId = data?.fhirServer[0]?.id;
    if (fhirServerId) {
      return <Navigate to={`/integrations/fhir-servers/${fhirServerId}`} replace />;
    }
  }

  const fhirServer = data?.fhirServer.find(fs => fs.id === id)

  return <Container maxWidth={false} sx={{ mt: 4, mb: 4 }}>
    <Grid container spacing={2}>
      <Grid size={{ xs: 12, md: 4, lg: 3, xl: 2 }}>
        <Tabs
          value={id}
          onChange={(_, newValue) => { navigate(`/integrations/fhir-servers/${newValue}`); }}
          orientation="vertical"
          variant="scrollable"
          sx={{ maxHeight: 400 }}
          visibleScrollbar={true}
        >
          {data?.fhirServer.map((fs) => fs && <Tab key={fs.id} label={<>
            {fs.fhirProvider} - {fs.url.replace('https://', '') || "No url configured"}
            {fs.active ? '' : <><br />(Inactive)</>}
          </>
          } value={fs.id} />)}
        </Tabs>
        <Button
          variant="contained"
          color="primary"
          disabled={loading}
          onClick={() => setCreateOpen(true)}
          sx={{ mt: 2, width: "100%" }}
        >
          Add FHIR Server
        </Button>
      </Grid>

      <Grid size={{ xs: 12, md: 8, lg: 9, xl: 10 }}>
        {fhirServer && <FhirServer key={id} fhirServer={fhirServer} />}
      </Grid>
    </Grid>

    {createOpen && <CreateFhirServerDialog onClose={() => setCreateOpen(false)} />}
  </Container>
}

export default TabEhrIntegration;

gql`
  query FhirServers @permission(requires: manageOrgConfig) {
    fhirServer(orderBy: { active: { direction: desc, priority: 1 } }) {
      id
      active
      fhirProvider
      useForLogin
      url
      hl7Folder
    }
  }
`;
